import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreelancerAsyncPipe } from './async.pipe';

@NgModule({
  declarations: [FreelancerAsyncPipe],
  exports: [FreelancerAsyncPipe],
  providers: [AsyncPipe, FreelancerAsyncPipe],
})
export class FreelancerAsyncPipeModule {}
